// src/components/Events/Events.js

import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import './Events.css';

const Events = () => {
  const [years, setYears] = useState([]);
  const [selectedYearId, setSelectedYearId] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const BASE_URL = 'https://blog.dietchapter.hosting.acm.org/'; // Base URL for uploaded files

  useEffect(() => {
    fetchYears();
  }, []);

  const fetchYears = async () => {
    setLoading(true);
    try {
      // Backend should return years sorted by creation date DESC (newest first)
      const res = await axios.get('/events'); 
      setYears(res.data);
      
      if (res.data.length > 0) {
        // Default to the first year in the sorted list (the newest year)
        setSelectedYearId(res.data[0].id); 
      }
    } catch (err) {
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  const selectedYear = years.find((year) => year.id === selectedYearId);
  const eventsToDisplay = selectedYear?.Events || [];

  const formatPath = (path) => {
      // Replaces backslashes for proper URL usage, prepends base URL
      return `${BASE_URL}/${path.replace(/\\/g, '/')}`;
  };

  // Functionality: Clicking the card image/title should open the PDF report
  const handleCardClick = (reportPath) => {
    if (reportPath) {
        window.open(formatPath(reportPath), '_blank');
    }
  };
  
  if (loading) {
    return <div className="events-page loading-page">Loading events history...</div>;
  }
  
  return (
    <section id="events-page" className="events-page">
        <div className="events-header">
            <h2 className="section-title">OUR EVENTS</h2>
            <p className="section-subtitle">
                Explore the exciting events organized by DIET ACM Student Chapter over the 
                years. From technical workshops to hackathons, discover our journey of 
                innovation and learning.
            </p>
        </div>
        
        {/* Year/Filter Buttons */}
        <div className="year-filter-container">
             <div className="year-buttons">
                {years.map((year) => (
                <button
                    key={year.id}
                    className={`year-button ${selectedYearId === year.id ? 'active' : ''}`}
                    onClick={() => setSelectedYearId(year.id)}
                >
                    {year.label}
                </button>
                ))}
                
                {/* REMOVED: Static 'All Years' button */}
            </div>
        </div>


      {eventsToDisplay.length > 0 ? (
        <div className="events-grid">
          {eventsToDisplay.map((event) => (
            <div 
                className="event-card" 
                key={event.id}
                onClick={() => handleCardClick(event.reportPath)}
            >
              
              <img
                src={formatPath(event.posterPath)}
                alt={event.name}
                className="event-image"
              />
              
              <div className="event-content">
                    <div className="event-meta">
                        <span className="event-type">{event.eventType}</span>
                        <span className="event-date">{event.date}</span>
                    </div>
                    
                    <h3 className="event-title">
                        {event.name}
                    </h3>

                    <p className="event-description">
                        {event.description}
                    </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="no-events">No events found for this academic year ({selectedYear?.label}).</p>
      )}
    </section>
  );
};

export default Events;